import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4849d508"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oktell-calculator__container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__title" }, "Выберите тариф", -1))
const _hoisted_3 = { class: "container__content" }
const _hoisted_4 = { class: "content__row row--2" }
const _hoisted_5 = { class: "oktell-calculator__container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__title" }, "Укажите город отправлений и город прибытий", -1))
const _hoisted_7 = { class: "container__content" }
const _hoisted_8 = { class: "content__row row--2" }
const _hoisted_9 = { class: "oktell-calculator__container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__title" }, "Заполните данные о грузе", -1))
const _hoisted_11 = { class: "container__content" }
const _hoisted_12 = { class: "content__row row--2" }
const _hoisted_13 = { class: "content__place" }
const _hoisted_14 = { class: "place__header" }
const _hoisted_15 = { class: "place__title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_17 = { class: "place__container" }
const _hoisted_18 = { class: "flex items-center justify-end mt-4" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_20 = { class: "oktell-calculator__container" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__title" }, "Выберите способ доставки", -1))
const _hoisted_22 = { class: "container__content" }
const _hoisted_23 = { class: "content__delivery-type" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "type__name" }, "Самовывоз", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "type__name" }, "Самопривоз", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "type__name" }, "Сбор за оформление заказа", -1))
const _hoisted_27 = { class: "oktell-calculator__container" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__title" }, "Дополнительные услуги", -1))
const _hoisted_29 = { class: "container__content" }
const _hoisted_30 = { class: "content__row row--3" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__subtitle" }, "Манипулятор", -1))
const _hoisted_32 = { class: "content__row row--3 mt-4" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__subtitle" }, "Кран", -1))
const _hoisted_34 = { class: "content__row row--3 mt-4" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__subtitle" }, "Грузчики", -1))
const _hoisted_36 = { class: "content__row row--2 mt-4" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content__subtitle" }, "Рохля", -1))
const _hoisted_38 = { class: "content__row row--2 mt-4" }
const _hoisted_39 = { class: "oktell-calculator__container" }
const _hoisted_40 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ok_select = _resolveComponent("ok-select")!
  const _component_ok_input = _resolveComponent("ok-input")!
  const _component_ok_button = _resolveComponent("ok-button")!
  const _component_ok_checkbox = _resolveComponent("ok-checkbox")!

  return (_openBlock(), _createElementBlock("form", {
    class: "oktell-calculator",
    onSubmit: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitForm && _ctx.onSubmitForm(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_ok_select, {
            name: "Тариф",
            placeholder: "Выберите тариф",
            value: _ctx.state.tariff_id,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.tariff_id) = $event)),
            disabled: _ctx.loading || _ctx.state.is_loading,
            searchable: false,
            options: _ctx.CALCULATOR_TARIFFS,
            "is-invalid": _ctx.state_form$.tariff_id.$error,
            "validation-errors": _ctx.state_form$.tariff_id.$errors,
            onChange: _ctx.onTypeChange
          }, null, 8, ["value", "disabled", "options", "is-invalid", "validation-errors", "onChange"]),
          (_ctx.state.tariff_id !== 1)
            ? (_openBlock(), _createBlock(_component_ok_select, {
                key: 0,
                name: "Компания",
                placeholder: "Компания",
                disabled: _ctx.loading || _ctx.state.is_loading || _ctx.direction_state.is_loading,
                loading: _ctx.data_state.companies.is_loading || _ctx.direction_state.is_loading,
                failed: _ctx.data_state.companies.is_failed,
                "error-text": "При получении списка компаний отправлений произошла ошибка",
                options: _ctx.data_state.companies.list,
                value: _ctx.state.company_id,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.company_id) = $event)),
                "search-without-refresh": "",
                label: "short_name",
                onRefresh: _ctx.loadCompanies
              }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_ok_select, {
            name: "Город отправлений",
            placeholder: "Город отправлений",
            disabled: _ctx.loading || _ctx.state.is_loading || _ctx.direction_state.is_loading,
            loading: _ctx.data_state.from_cities.is_loading || _ctx.direction_state.is_loading,
            failed: _ctx.data_state.from_cities.is_failed,
            "error-text": "При получении списка городов отправлений произошла ошибка",
            options: _ctx.data_state.from_cities.list,
            "is-invalid": _ctx.state_form$.from_city.$error,
            "validation-errors": _ctx.state_form$.from_city.$errors,
            value: _ctx.state.from_city_id,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.from_city_id) = $event)),
            "search-without-refresh": "",
            onRefresh: _ctx.loadFromCities,
            onChange: _ctx.onFromCityChange
          }, null, 8, ["disabled", "loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh", "onChange"]),
          _createVNode(_component_ok_select, {
            name: "Город прибытий",
            placeholder: "Город прибытий",
            disabled: _ctx.loading || _ctx.state.is_loading || _ctx.direction_state.is_loading,
            loading: _ctx.data_state.where_cities.is_loading || _ctx.direction_state.is_loading,
            failed: _ctx.data_state.where_cities.is_failed,
            "error-text": "При получении списка городов прибытий произошла ошибка",
            options: _ctx.data_state.where_cities.list,
            "is-invalid": _ctx.state_form$.where_city.$error,
            "validation-errors": _ctx.state_form$.where_city.$errors,
            value: _ctx.state.where_city_id,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.where_city_id) = $event)),
            "search-without-refresh": "",
            onRefresh: _ctx.loadWhereCities,
            onChange: _ctx.onWhereCityChange
          }, null, 8, ["disabled", "loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh", "onChange"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_ok_input, {
            name: "Объявленная стоимость",
            placeholder: "Объявленная стоимость",
            value: _ctx.state.declaredPrice,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.declaredPrice) = $event)),
            disabled: _ctx.loading,
            "is-invalid": _ctx.state_form$.declaredPrice.$error,
            "validation-errors": _ctx.state_form$.declaredPrice.$errors
          }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
          _createVNode(_component_ok_input, {
            name: "Наименование товара",
            placeholder: "Наименование товара",
            value: _ctx.state.productName,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.productName) = $event)),
            disabled: _ctx.loading
          }, null, 8, ["value", "disabled"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.volumeWeight, (volume_weight, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `volumeWeight-${i}`
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, "Место #" + _toDisplayString(i + 1), 1),
                (_ctx.state.volumeWeight.length > 1)
                  ? (_openBlock(), _createBlock(_component_ok_button, {
                      key: 0,
                      class: "OkButton--red OkButton--xs",
                      disabled: _ctx.loading,
                      onClick: ($event: any) => (_ctx.removePlace(i))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_ok_input, {
                  name: "Вес отправления (кг)",
                  placeholder: "Вес отправления (кг)",
                  disabled: _ctx.loading || _ctx.state.is_loading,
                  value: _ctx.state.physicalWeights[i].weight,
                  "onUpdate:value": ($event: any) => ((_ctx.state.physicalWeights[i].weight) = $event)
                }, null, 8, ["disabled", "value", "onUpdate:value"]),
                _createVNode(_component_ok_input, {
                  name: "Длина отправления (см)",
                  placeholder: "Длина отправления (см)",
                  disabled: _ctx.loading || _ctx.state.is_loading,
                  value: _ctx.state.volumeWeight[i].length,
                  "onUpdate:value": ($event: any) => ((_ctx.state.volumeWeight[i].length) = $event)
                }, null, 8, ["disabled", "value", "onUpdate:value"]),
                _createVNode(_component_ok_input, {
                  name: "Ширина отправления (см)",
                  placeholder: "Ширина отправления (см)",
                  disabled: _ctx.loading || _ctx.state.is_loading,
                  value: _ctx.state.volumeWeight[i].width,
                  "onUpdate:value": ($event: any) => ((_ctx.state.volumeWeight[i].width) = $event)
                }, null, 8, ["disabled", "value", "onUpdate:value"]),
                _createVNode(_component_ok_input, {
                  name: "Высота отправления (см)",
                  placeholder: "Высота отправления (см)",
                  disabled: _ctx.loading || _ctx.state.is_loading,
                  value: _ctx.state.volumeWeight[i].height,
                  "onUpdate:value": ($event: any) => ((_ctx.state.volumeWeight[i].height) = $event)
                }, null, 8, ["disabled", "value", "onUpdate:value"])
              ])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_ok_button, {
            class: "OkButton--xs OkButton--blue",
            disabled: _ctx.loading,
            onClick: _ctx.addPlace
          }, {
            default: _withCtx(() => [
              _hoisted_19,
              _createTextVNode(" Добавить место ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", {
            class: "delivery-type__type",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onToggleIsHasPickup && _ctx.onToggleIsHasPickup(...args)))
          }, [
            _createVNode(_component_ok_checkbox, {
              checked: _ctx.state.is_has_pickup,
              disabled: _ctx.loading || _ctx.state.is_loading
            }, null, 8, ["checked", "disabled"]),
            _hoisted_24
          ]),
          _createElementVNode("div", {
            class: "delivery-type__type",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onToggleIsHasSelfDelivery && _ctx.onToggleIsHasSelfDelivery(...args)))
          }, [
            _createVNode(_component_ok_checkbox, {
              checked: _ctx.state.is_has_self_delivery,
              disabled: _ctx.loading || _ctx.state.is_loading
            }, null, 8, ["checked", "disabled"]),
            _hoisted_25
          ]),
          _createElementVNode("div", {
            class: "delivery-type__type",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onToggleIsOrderPrice && _ctx.onToggleIsOrderPrice(...args)))
          }, [
            _createVNode(_component_ok_checkbox, {
              checked: _ctx.state.isOrderPrice,
              disabled: _ctx.loading || _ctx.state.is_loading
            }, null, 8, ["checked", "disabled"]),
            _hoisted_26
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _hoisted_28,
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_ok_input, {
            name: "Мягкая упаковка (куб. метры)",
            placeholder: "Мягкая упаковка (куб. метры)",
            value: _ctx.state.additional_services.soft_package_value,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.additional_services.soft_package_value) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.soft_package_value.$error,
            "validation-errors": 
                            _ctx.state_form$.additional_services.soft_package_value.$errors
                        ,
            disabled: _ctx.loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
          _createVNode(_component_ok_input, {
            name: "Паллета (куб. метры)",
            placeholder: "Паллета (куб. метры)",
            value: _ctx.state.additional_services.pallet_value,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.additional_services.pallet_value) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.pallet_value.$error,
            "validation-errors": _ctx.state_form$.additional_services.pallet_value.$errors,
            disabled: _ctx.loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
          _createVNode(_component_ok_input, {
            name: "Обрешетка (куб. метры)",
            placeholder: "Обрешетка (куб. метры)",
            value: _ctx.state.additional_services.grid_value,
            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.additional_services.grid_value) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.grid_value.$error,
            "validation-errors": _ctx.state_form$.additional_services.grid_value.$errors,
            disabled: _ctx.loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"])
        ]),
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_ok_input, {
            name: "Количество",
            placeholder: "Количество",
            value: _ctx.state.additional_services.manipulator_value,
            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.additional_services.manipulator_value) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.manipulator_value.$error,
            "validation-errors": 
                            _ctx.state_form$.additional_services.manipulator_value.$errors
                        ,
            disabled: _ctx.loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
          _createVNode(_component_ok_input, {
            name: "Отработанные часы",
            placeholder: "Отработанные часы",
            value: _ctx.state.additional_services.manipulator_duration,
            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.additional_services.manipulator_duration) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.manipulator_duration.$error,
            "validation-errors": 
                            _ctx.state_form$.additional_services.manipulator_duration.$errors
                        ,
            disabled: _ctx.loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
          _createVNode(_component_ok_input, {
            name: "Себестоимость за час",
            placeholder: "Себестоимость за час",
            value: _ctx.state.additional_services.manipulator_costPerHour,
            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.additional_services.manipulator_costPerHour) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.manipulator_costPerHour.$error,
            "validation-errors": 
                            _ctx.state_form$.additional_services.manipulator_costPerHour.$errors
                        ,
            disabled: _ctx.loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"])
        ]),
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_ok_input, {
            name: "Количество",
            placeholder: "Количество",
            value: _ctx.state.additional_services.crane_value,
            "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.additional_services.crane_value) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.crane_value.$error,
            "validation-errors": _ctx.state_form$.additional_services.crane_value.$errors,
            disabled: _ctx.loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
          _createVNode(_component_ok_input, {
            name: "Отработанные часы",
            placeholder: "Отработанные часы",
            value: _ctx.state.additional_services.crane_duration,
            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.additional_services.crane_duration) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.crane_duration.$error,
            "validation-errors": _ctx.state_form$.additional_services.crane_duration.$errors,
            disabled: _ctx.loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
          _createVNode(_component_ok_input, {
            name: "Себестоимость за час",
            placeholder: "Себестоимость за час",
            value: _ctx.state.additional_services.crane_costPerHour,
            "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.additional_services.crane_costPerHour) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.crane_costPerHour.$error,
            "validation-errors": 
                            _ctx.state_form$.additional_services.crane_costPerHour.$errors
                        ,
            disabled: _ctx.loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"])
        ]),
        _hoisted_35,
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_ok_input, {
            name: "Количество",
            placeholder: "Количество",
            value: _ctx.state.additional_services.loader_value,
            "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.additional_services.loader_value) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.loader_value.$error,
            "validation-errors": _ctx.state_form$.additional_services.loader_value.$errors,
            disabled: _ctx.loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
          _createVNode(_component_ok_input, {
            name: "Отработанные часы",
            placeholder: "Отработанные часы",
            value: _ctx.state.additional_services.loader_duration,
            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.additional_services.loader_duration) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.loader_duration.$error,
            "validation-errors": _ctx.state_form$.additional_services.loader_duration.$errors,
            disabled: _ctx.loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"])
        ]),
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_ok_input, {
            name: "Количество",
            placeholder: "Количество",
            value: _ctx.state.additional_services.hydraulic_trolley_value,
            "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.additional_services.hydraulic_trolley_value) = $event)),
            "is-invalid": _ctx.state_form$.additional_services.hydraulic_trolley_value.$error,
            "validation-errors": 
                            _ctx.state_form$.additional_services.hydraulic_trolley_value.$errors
                        ,
            disabled: _ctx.loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
          _createVNode(_component_ok_input, {
            name: "Отработанные часы",
            placeholder: "Отработанные часы",
            value: _ctx.state.additional_services.hydraulic_trolley_duration,
            "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.additional_services.hydraulic_trolley_duration) = $event)),
            "is-invalid": 
                            _ctx.state_form$.additional_services.hydraulic_trolley_duration.$error
                        ,
            "validation-errors": 
                            _ctx.state_form$.additional_services.hydraulic_trolley_duration.$errors
                        ,
            disabled: _ctx.loading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createVNode(_component_ok_button, {
          type: "submit",
          disabled: _ctx.loading,
          loading: _ctx.loading,
          class: "OkButton--blue OkButton--small"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Рассчитать стоимость")
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ])
  ], 32))
}